import { Model as a } from "../../../../model.js";
class l extends a {
  constructor(o) {
    super(), this.productCatalogMode = o.productCatalogMode, this.balance = o.balance, this.applicationRules = o.applicationRules;
  }
}
export {
  l as StampProgrammeSettingsModel
};
//# sourceMappingURL=stampProgrammeSettigns.model.js.map
